import './form.scss';
import Component from '../../components/component/component';


export default class Form extends Component {
    static initSelector: string = '.form';

    constructor(target: HTMLElement) {
        super(target);

        this.init();
    }

    init(): void {
        const formElement: JQuery<HTMLElement> = this.element.find('form');
        const formTitle: string = formElement.attr('data-form-title');

        $(document).on('gform_confirmation_loaded', (e: JQuery.TriggeredEvent, formId: number): void => {

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'generate_lead',
                content: {
                    id: formId,
                    name: formTitle,
                },
            });
        });
    }
}
